/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiEmployeesIdCvSummaryPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiEmployeesIdCvSummary200Schema = z.object({
  hasOriginal: z.boolean(),
  hasPdfPreview: z.boolean(),
  fileName: z.coerce.string().nullable().nullish(),
  contentType: z.coerce.string().nullable().nullish(),
  fileExtension: z.coerce.string().nullable().nullish(),
  fileSizeBytes: z.coerce.number().int().nullable().nullish(),
  uploadedAt: z.string().datetime({ local: true }).nullable().nullish(),
  updatedAt: z.string().datetime({ local: true }).nullable().nullish(),
  cvUpdateRequested: z.boolean(),
  cvUpdateRequestedAt: z
    .string()
    .datetime({ local: true })
    .nullable()
    .nullish(),
  cvLastUpdatedAt: z.string().datetime({ local: true }).nullable().nullish(),
});

export const getApiEmployeesIdCvSummaryQueryResponseSchema = z.lazy(
  () => getApiEmployeesIdCvSummary200Schema,
);
